import createReactComponent from '../createReactComponent';
export default createReactComponent('map-north', 'IconMapNorth', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 15v-6l4 6v-6', key: 'svg-1' }],
]);
